module.exports = __webpack_public_path__ + "static/media/sixsense-gallery-6.0d1d1dbb.jpg";